module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-默认图标-媒体.888d6.png";